import { useNavigate } from "@/lib/router-compat";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

export interface NewsArticle {
  slug: string;
  title: string;
  date: string;
  excerpt: string;
  image?: string;
}

export const newsArticles: NewsArticle[] = [
  {
    slug: "de-hussel-app-is-live",
    title: "De Hussel App is live — het tennisseizoen kan beginnen!",
    date: "26/02/2026",
    excerpt:
      "De banen liggen er perfect bij, de zon breekt door en het nieuwe tennisseizoen staat voor de deur. Tijd om de rackets uit de tas te halen en weer volop te gaan spelen. En dit seizoen wordt alles nóg makkelijker: De Hussel App is officieel gelanceerd!",
  },
];

const Nieuws = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <ContentPageNav showPricing={false} />

      <main className="container mx-auto max-w-4xl px-3 py-8 md:py-20">
        <h1 className="text-2xl md:text-5xl font-bold text-foreground mb-2">Nieuws</h1>
        <p className="text-muted-foreground mb-10 text-lg">
          Het laatste nieuws over De Hussel App en de tenniswereld.
        </p>

        <div className="grid gap-6">
          {newsArticles.map((article) => (
            <Card
              key={article.slug}
              className="overflow-hidden hover:border-accent/50 transition-colors cursor-pointer"
              onClick={() => navigate(`/nieuws/${article.slug}`)}
            >
              <CardContent className="p-4 md:p-8">
                <time className="text-sm text-muted-foreground">{article.date}</time>
                <h2 className="text-xl md:text-2xl font-bold text-foreground mt-1 mb-3">
                  {article.title}
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">{article.excerpt}</p>
                <Button variant="default" className="gap-2">
                  Lees nu <ArrowRight className="h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Nieuws;
